import './HelpDetails.css';

// Secondary explanations only: required consent and actionable warnings stay outside.
export default function HelpDetails({ title, children }) {
  return <details className="rd-help-details"><summary>{title}</summary><div>{children}</div></details>;
}
